import React from 'react'
import { useTranslation } from 'react-i18next'
import MainIcon from '../../../img/svg/main'
import TableTdElementsTooltip from '../../Elements/table/TableTdElements/TableTdElementsTooltip'
import { SALES_TRANSFER_STATE_FAILED } from '../constants'
import { FolioMarkerWrap } from './index.styled'

type Props = {
	salesTransferState?: string
}

const RoomChargeFolioMarker = React.memo(({ salesTransferState }: Props) => {
	const { t } = useTranslation()

	if (salesTransferState !== SALES_TRANSFER_STATE_FAILED) return null

	return (
		<TableTdElementsTooltip text={t('RoomCharge.orders.folioError')}>
			<FolioMarkerWrap data-testid="room-charge-folio-marker">
				<MainIcon icon="room-charge-folio-error" />
			</FolioMarkerWrap>
		</TableTdElementsTooltip>
	)
})

RoomChargeFolioMarker.displayName = 'RoomChargeFolioMarker'
export default RoomChargeFolioMarker
